import { render } from "./갤러리형.vue?vue&type=template&id=fc68076a"
import script from "./갤러리형.vue?vue&type=script&lang=js"
export * from "./갤러리형.vue?vue&type=script&lang=js"

import "./갤러리형.vue?vue&type=style&index=0&id=fc68076a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__